"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var _validate = require("@/utils/validate");
var _common = require("./common");
var _enum = require("../enum");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  data: function data() {
    return {
      stepsEnum: _enum.stepsEnum,
      active: 0,
      submitLoading: false,
      ID: this.$route.params.id,
      form: {},
      childsRefs: [],
      newForm: {},
      userType: null
    };
  },
  created: function created() {
    this.userType = JSON.parse(_jsCookie.default.get('JavaInfo')).type;
    if (this.userType != 1) {
      this.stepsEnum = _enum.stepsEnum.filter(function (item) {
        return item.value != 3;
      });
      console.log(this.stepsEnum, 'stepsEnum');
    }
    (0, _common.init)();
    this.handleDetailList();
  },
  mounted: function mounted() {
    var _this = this;
    this.hasConfirm = null;
    // Initialize refs in $nextTick to ensure they're available
    this.$nextTick(function () {
      _this.childsRefs = [_this.$refs.goodsInfoRef, _this.$refs.specificationsAndInventoryRef, _this.$refs.goodsDetailRef, _this.$refs.otherRef];
      if (_this.ID) {
        _this.setTagsViewTitle();
        _this.getInfo();
      }
    });
  },
  methods: {
    getProductListPath: function getProductListPath() {
      return this.$route.query && this.$route.query.source === 'sku' ? '/store/goodsManage/sku' : '/store/goodsManage/spu';
    },
    getProductListLocation: function getProductListLocation() {
      var listPath = this.getProductListPath();
      var query = this.$route.query || {};
      var returnTo = query.returnTo;
      var hasMatchingReturnRoute = typeof returnTo === 'string' && (returnTo === listPath || returnTo.indexOf("".concat(listPath, "?")) === 0);
      return hasMatchingReturnRoute ? returnTo : {
        path: listPath
      };
    },
    handleEdit: function () {
      var _handleEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.$confirm('是否保存本次填写内容', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                var res;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      res = _this2.handleForm(_this2.newForm);
                      _this2.$router.go(-1);
                      // const data= await storeApi.getProductSave(res)

                      // this.$message.success('保存成功')
                      // console.log(data);
                      //     }).catch(async ()=>{
                      //        const res= storeApi.getProductRemoveByProduct(this.newForm?.id?this.newForm?.id:0)
                      //             this.$message.success('取消成功')
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              })));
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleEdit() {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDetailList: function () {
      var _handleDetailList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function handleDetailList() {
        return _handleDetailList.apply(this, arguments);
      }
      return handleDetailList;
    }(),
    formChange: function () {
      var _formChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(val) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.newForm = val;
              if (val && val.isIntegralExchange != null) {
                this.$set(this.form, 'isIntegralExchange', val.isIntegralExchange);
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function formChange(_x) {
        return _formChange.apply(this, arguments);
      }
      return formChange;
    }(),
    setTagsViewTitle: function setTagsViewTitle() {
      var _this$$route = this.$route,
        path = _this$$route.path,
        fullPath = _this$$route.fullPath,
        query = _this$$route.query,
        params = _this$$route.params,
        name = _this$$route.name,
        meta = _this$$route.meta;
      var route = {
        path: path,
        fullPath: fullPath,
        query: query,
        params: params,
        name: name,
        meta: meta,
        title: "\u7F16\u8F91\u5546\u54C1-".concat(this.ID)
      };
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    changeStep: function () {
      var _changeStep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(n) {
        var _this$childsRefs$this, form, validate, _t;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!this.childsRefs || !this.childsRefs[this.active])) {
                _context5.n = 1;
                break;
              }
              console.error('Child refs not available');
              return _context5.a(2);
            case 1:
              _this$childsRefs$this = this.childsRefs[this.active], form = _this$childsRefs$this.form, validate = _this$childsRefs$this.validate; // 合并而非替换，避免 isIntegralExchange 等跨步骤字段丢失
              this.form = _objectSpread(_objectSpread({}, this.form), form);
              if (!(n > 0)) {
                _context5.n = 6;
                break;
              }
              _context5.p = 2;
              _context5.n = 3;
              return validate();
            case 3:
              this.active += n;
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t = _context5.v;
              this.$message.warning('请完善信息');
              console.error('Validation error:', _t);
            case 5:
              _context5.n = 7;
              break;
            case 6:
              // Moving backward - no validation needed
              this.active += n;
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 4]]);
      }));
      function changeStep(_x2) {
        return _changeStep.apply(this, arguments);
      }
      return changeStep;
    }(),
    handleInfo: function handleInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref2 = data || {},
        authMsg = _ref2.authMsg,
        productAttr = _ref2.productAttr,
        cateId = _ref2.cateId,
        productArea = _ref2.productArea,
        labelId = _ref2.labelId,
        channelIds = _ref2.channelIds,
        customerStr = _ref2.customerStr,
        attrValue = _ref2.attrValue,
        brandId = _ref2.brandId,
        brandName = _ref2.brandName,
        isShow = _ref2.isShow,
        sliderImage = _ref2.sliderImage,
        content = _ref2.content,
        image = _ref2.image,
        isBrandAuthorize = _ref2.isBrandAuthorize;
      var info = _objectSpread(_objectSpread({}, data), {}, {
        productAttr: productAttr ? productAttr.split(',') : [],
        brandIdObj: {
          id: brandId,
          brandName: brandName
        },
        isShow: isShow ? 1 : 0,
        authMsg: authMsg ? 1 : 0,
        isBrandAuthorize: isBrandAuthorize !== null ? isBrandAuthorize ? 1 : 0 : null,
        sliderImages: sliderImage ? JSON.parse(sliderImage) : sliderImage,
        cateIds: cateId ? cateId.split(',').map(function (j) {
          return Number(j);
        }) : [],
        // 商品分类id
        areaId: productArea ? productArea.split(',').map(function (j) {
          return Number(j);
        }) : [],
        //产地
        labelId: labelId ? labelId.split(',').map(function (j) {
          return Number(j);
        }) : [],
        //商品标签
        // channelIds: channelIds ? channelIds.split(',').map((j) => Number(j)) : [], //商品标签
        image: image && this.$selfUtil.setDomain(image),
        content: content && this.$selfUtil.replaceImgSrcHttps(content),
        attrValue: attrValue && attrValue.length ? attrValue.map(function (item) {
          var _ref3 = item || {},
            image = _ref3.image,
            attrValue = _ref3.attrValue;
          var imgList = image && image.split(',') || [];
          return _objectSpread(_objectSpread(_objectSpread({}, item), attrValue && JSON.parse(attrValue) || {}), {}, {
            attrValue: attrValue && JSON.parse(attrValue),
            image: imgList && imgList.length && imgList.filter(function (img) {
              return img && img != 0;
            }) || []
          });
        }) : []
      });
      return info;
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this3 = this;
        var loading;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              this.$refs.specificationsAndInventoryRef && this.$refs.specificationsAndInventoryRef.clearInit();
              // try {
              storeApi.productDetailApi(this.ID).then(function (res) {
                _this3.form = _this3.handleInfo(res);
                loading.close();
              }).catch(function (err) {
                loading.close();
              });
              // } catch (error) {
              // loading.close();
              // this.$message.error('处理信息失败!');
              // }
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    handleForm: function handleForm(form) {
      var _newForm2, _newForm2$brandIdObj;
      var newForm = _objectSpread({}, form);
      var _newForm = newForm,
        _newForm$labelId = _newForm.labelId,
        labelId = _newForm$labelId === void 0 ? [] : _newForm$labelId,
        _newForm$channelIds = _newForm.channelIds,
        channelIds = _newForm$channelIds === void 0 ? [] : _newForm$channelIds,
        _newForm$cateIds = _newForm.cateIds,
        cateIds = _newForm$cateIds === void 0 ? [] : _newForm$cateIds,
        _newForm$areaId = _newForm.areaId,
        areaId = _newForm$areaId === void 0 ? [] : _newForm$areaId,
        _newForm$productAttr = _newForm.productAttr,
        productAttr = _newForm$productAttr === void 0 ? [] : _newForm$productAttr,
        syncList = _newForm.syncList,
        _newForm$attrValue = _newForm.attrValue,
        attrValue = _newForm$attrValue === void 0 ? [] : _newForm$attrValue;
      newForm.specType = true;
      newForm.isSub = false;
      newForm.keyword = newForm.storeName;
      if (newForm.sliderImages) {
        newForm.image = newForm.sliderImages[0];
      }
      console.log(newForm.labelId);
      newForm.brandId = (_newForm2 = newForm) === null || _newForm2 === void 0 ? void 0 : (_newForm2$brandIdObj = _newForm2.brandIdObj) === null || _newForm2$brandIdObj === void 0 ? void 0 : _newForm2$brandIdObj.id;
      newForm.labelId = labelId && labelId.length && labelId.join(',');
      // newForm.channelIds = channelIds && channelIds.length && channelIds.join(',');
      newForm.cateId = cateIds && cateIds.length && cateIds.join(',');
      newForm.productArea = areaId && areaId.length && areaId.join(',');
      newForm.productAttr = productAttr && productAttr.length && productAttr.join(',');
      newForm.deliveryTime = newForm.deliveryTime === 'other' ? newForm.deliveryTimeOther : newForm.deliveryTime;
      newForm.sliderImage = JSON.stringify(newForm.sliderImages);
      newForm.attrValue = attrValue && attrValue.length ? attrValue.map(function (item) {
        var _ref4 = item || {},
          image = _ref4.image,
          attrValue = _ref4.attrValue;
        return _objectSpread(_objectSpread({
          id: 0,
          productId: 0
        }, item), {}, {
          image: image && image.length && image.join(','),
          attrValue: attrValue ? JSON.stringify(attrValue) : ''
        });
      }) : [];
      newForm.brandIdObj && delete newForm.brandIdObj;
      newForm.cateIds && delete newForm.cateIds;
      if (newForm && newForm.productType == 3) {
        var couponSkuInfo = this.$refs.specificationsAndInventoryRef && this.$refs.specificationsAndInventoryRef.couponSkuInfo;
        var _ref5 = couponSkuInfo || {},
          listStatus = _ref5.listStatus,
          attrImage = _ref5.attrImage,
          skuCode = _ref5.skuCode,
          cpStatus = _ref5.cpStatus,
          id = _ref5.id,
          _ref5$image = _ref5.image,
          image = _ref5$image === void 0 ? [] : _ref5$image,
          otPrice = _ref5.otPrice,
          skuName = _ref5.skuName,
          stock = _ref5.stock,
          stockWarning = _ref5.stockWarning,
          supplyPrice = _ref5.supplyPrice,
          suk = _ref5.suk,
          couponId = _ref5.couponId,
          defaultPrice = _ref5.defaultPrice,
          guidePrice = _ref5.guidePrice,
          barCode = _ref5.barCode;
        var _ref6 = newForm || {},
          _ref6$attr = _ref6.attr,
          attr = _ref6$attr === void 0 ? [] : _ref6$attr,
          _ref6$attrValue = _ref6.attrValue,
          _attrValue = _ref6$attrValue === void 0 ? [] : _ref6$attrValue;
        var attrInfo = {
          attrImage: attrImage,
          skuCode: skuCode,
          cpStatus: cpStatus,
          barCode: barCode,
          id: _attrValue && _attrValue.length && _attrValue[0].id,
          image: image.length && image.join(','),
          attrValue: JSON.stringify({
            '规格': suk
          }),
          cpMinQuantity: 0,
          cpSupplyPrice: 0,
          // grossMargin: ,
          listStatus: listStatus,
          defaultPrice: defaultPrice,
          guidePrice: guidePrice,
          otPrice: otPrice,
          skuName: skuName,
          stock: stock,
          stockWarning: stockWarning,
          supplyPrice: supplyPrice
        };
        var couponSkuAttr = [{
          attrName: '规格',
          attrValues: suk,
          id: attr && attr.length && attr[0].id,
          productId: newForm.id
        }];
        newForm = _objectSpread(_objectSpread({}, newForm), {}, {
          couponId: couponId,
          attr: couponSkuAttr,
          attrValue: [attrInfo]
        });
      }
      return newForm;
    },
    submit: (0, _validate.Debounce)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var _this4 = this;
      var submitForm, refsToValidate, valid, params;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            submitForm = this.childsRefs[this.active] && this.childsRefs[this.active].form; // 根据userType决定需要校验的步骤
            refsToValidate = this.userType !== 1 ? this.childsRefs.slice(0, 3) // userType不为1时，只校验前3个步骤
            : this.childsRefs; // userType为1时，校验所有步骤
            _context7.n = 1;
            return Promise.all(refsToValidate.map(function (item) {
              return item ? item.validate() : true;
            }));
          case 1:
            valid = _context7.v;
            console.log('valid', valid);
            this.submitLoading = true;
            if (valid.every(function (item) {
              return item;
            })) {
              params = this.handleForm(submitForm);
              console.log('params', params);
              storeApi[this.ID ? 'productUpdateApi' : 'productCreateApi'](_objectSpread(_objectSpread({}, params), {}, {
                id: this.ID
              }), this.hasConfirm ? {
                hasConfirm: this.hasConfirm
              } : {}).then(function (res) {
                _this4.submitLoading = false;
                _this4.$closeCompletedView();
                _this4.$message.success('操作成功！');
                var listLocation = _this4.getProductListLocation();
                setTimeout(function () {
                  _this4.$router.push(listLocation);
                }, 300);
              }).catch(function (err) {
                var _ref8 = err && err.data || {},
                  code = _ref8.code,
                  msg = _ref8.msg;
                _this4.submitLoading = false;
                if (code == 601 && !_this4.hasConfirm) {
                  storeApi.checkComfirm(msg).then(function (res) {
                    _this4.hasConfirm = res && res.hasConfirm;
                    _this4.submit();
                  });
                }
              });
            }
          case 2:
            return _context7.a(2);
        }
      }, _callee7, this);
    })))
  }
};